<template>
  <div>
    <v-container :class="getbMenuBlock ? 'layout-webview' : 'layout-browser py-1'">
        <!--Seccion titulo-->
        <v-row class="d-flex mb-2 wrap_height_flex">
          <v-col>
            <HeaderVista :sTitulo="sTitulo" sColor="black--text">
              <template v-slot:icono>
                <v-icon large color="red"> fas fa-map-marked-alt </v-icon>
              </template>
            </HeaderVista>
          </v-col>
        </v-row>
        <!--Seccion contador-->
        <v-row no-gutters class="d-flex mb-0 mt-0 wrap_height_flex">
           <v-col>
            <InfoPuntosRealizados 
              :nPuntosRealizados = "nPuntosRealizados"
              :nPuntosTotales = "nPuntosTotales"
              :sTipoHorario = "sTipoHorario"
            />
          </v-col>
        </v-row>
        <v-row class="mt-1 wrap_height_flex">
          <v-col class="pt-1">
            <Buscador
              v-model="sFiltroBusqueda"
              :sPlaceholder="$STR.lblBuscarPunto"
              />
          </v-col>
        </v-row>
        <!--Seccion Cards Punto-->
        <div class="scroll-container">
          <v-col class="pa-0 mb-2" cols="12" v-for="punto in puntosAMostrar">
            <PuntoItemCard 
              :oPunto="punto" 
              :bShowBtnDetalle="true">
              <template v-slot:informacion="attr">
                <InformacionPunto
                  v-model="attr.bShowDetalle"
                  :sIdPunto="punto.sIdPunto"
                  :sDescripcion="punto.sDescripcion"
                  :sFoto="punto.sFoto"
                />
              </template>
            </PuntoItemCard>
          </v-col>
          <v-col class="pa-0 mb-2" cols="12" v-if="puntosAMostrar.length == 0" justify="center">
            <v-row no-gutters justify="center" align="center" class="mt-3">
              <span class="my-0 text-size-2">{{ $STR.msgSinResultados }}</span>
            </v-row>
          </v-col>
        </div>
        <v-sheet
          :z-index="100"
          class="text-center pb-6 contenedor-bottom"
          >
          <v-row no-gutters justify="center" align="center" class="mt-3" v-if="!bRondaCompletada">
            <v-col cols="6" xs="6" sm="4" md="4" lg="6" justify="center" align="center">
              <v-btn @click="onClickFinalizarRonda" large dark color="error" outlined class="btn-primary btn-rounded">
                {{ $STR.btnFinalizarRonda }}
              </v-btn>
            </v-col>  
            <v-col cols="6" xs="6" sm="4" md="4" lg="6" justify="center" align="center">
              <v-btn @click="onMarcarPunto" large dark color="primary" class="btn-primary btn-rounded">
                {{ $STR.btnMarcarPunto }}
              </v-btn>
            </v-col> 
          </v-row>
        </v-sheet>
    </v-container>


    <LecturaQR 
      v-if="isLecturaQR" 
      v-model="isLecturaQR"
      :activo="isLecturaQR"
      :onLecturaCompletada="onLecturaCompletada" 
      @cerrarQR="cerrarlector"
    />
    <LecturaNFC 
      v-if="isLecturaNFC" 
      v-model="isLecturaNFC"
      :onLecturaCompletada="onLecturaCompletada" 
      @cerrar="cerrarlector"
    />
    <DialogMensaje
      v-model="bDialog"
      :titulo="sTituloMensaje"
      :texto="sMensaje"
      :textoBtn="sTextoBtnAceptar"
      :bShowCancelar="bBtnCancelDialgo"
      @onAceptar="fAceptar"
    >
      <template v-slot:icono>
        <v-icon large color="red"> mdi-alert</v-icon>
      </template>
    </DialogMensaje>
  </div>
  
</template>
<script>
import RondasRepository  from '@/views/control-actividades/rondas/RondasRepository.js'
import HeaderVista from '@/components/HeaderVista.vue';
import InfoPuntosRealizados from '@/components/control-actividades/rondas/InfoPuntosRealizados.vue';
import InformacionPunto from '@/components/control-actividades/rondas/InformacionPunto.vue';
import PuntoItemCard from '@/components/PuntoItemCard.vue';
import LecturaQR from '@/components/LecturaQR.vue' 
import LecturaNFC from '@/components/LecturaNFC.vue' 
import DialogMensaje from '@/components/DialogMensaje.vue'
import Buscador from '@/components/Buscador.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'PuntosPorRonda',
  components: {
    HeaderVista,
      InfoPuntosRealizados,
      InformacionPunto,
      PuntoItemCard,
      LecturaQR,
      LecturaNFC,
      DialogMensaje,
      Buscador
  },
  data() {
    return {
      sIdRondaCalendario : '0',
      sTitulo: '',
      nPuntosRealizados: 0,
      nPuntosTotales: 0,
      sTipoHorario: 'Flexible',
      oRonda:{},
      bRondaCompletada: false,
      isLecturaQR: false,
      isLecturaNFC:false,
      nTecnologia: 0, // 0 - NFC, 1 - QR 
      bDialog: false,
      bBtnCancelDialgo: false,
      sTituloMensaje: '',
      sMensaje: '',
      sTextoBtnAceptar: '',
      fAceptar:()=>{},
      puntos: [],
      sFiltroBusqueda: null,
    };
  },
  mounted() {
    this.sIdRondaCalendario = this.$route.params.idRonda;
    this.onConsultarPuntos()
  },
  methods: {
    onConsultarPuntos(){
      this.oRonda = RondasRepository.onGetRondaById(this.sIdRondaCalendario)
      if(this.oRonda != undefined){
        this.sTitulo = this.oRonda.nombre
        this.sTipoHorario = this.oRonda.hora
        this.bRondaCompletada = this.oRonda.finalizado
      }
      const aPuntos = RondasRepository.onGetPuntosByRonda(this.sIdRondaCalendario)
      this.puntos = aPuntos.sort((a, b) => {
        return (a.sEstado === "Marcado") - (b.sEstado === "Marcado")
      });
      //console.log('aPuntosOrdenados', this.puntos);
      this.nPuntosRealizados = this.oRonda.nPuntosMarcados
      this.nPuntosTotales = this.oRonda.nPuntosTotales
    },
    escapeInternalQuotes(jsonString) {
      // Reemplazar las comillas internas en las cadenas JSON por comillas escapadas
      return jsonString.replace(/"(?![^{}]*[:])(?=[^{}]*{)/g, '\\"');
    },
    onMarcarPunto(){
      if(this.getbMarcacionQr){
        //this.onLecturaCompletada("PuntoMarcacion|5|290|2024-09-02 14:42:10")
        this.onClickLecturaQR()
      }else{
        //this.onLecturaCompletada("2652388298")
        this.onClickLecturaNFC()
      }
    },
    onFinalizarRonda(){
      this.$router.push(`/FinalizarRondaIncompleta/${this.sIdRondaCalendario}`);
    },
    onClickLecturaQR() {
      this.isLecturaQR = true
    },
    onClickLecturaNFC() {
      this.isLecturaNFC = true
    },
    onLecturaCompletada(sCodigo){
      this.cerrarlector()
      let oPunto = RondasRepository.onGetPuntoByCodigo(this.sIdRondaCalendario, sCodigo)
      if(oPunto !=undefined){
        if(oPunto.aPreguntas.length>0){
          this.$router.push(`/ListaVerificacionPunto/${this.sIdRondaCalendario}/${sCodigo}`);
        }else{
          this.$router.push(`/ReporteMarcacion/${this.sIdRondaCalendario}/${sCodigo}`);
        }
      }else{
        this.bDialog = true
        this.bBtnCancelDialgo = false
        this.sTituloMensaje = 'Punto no asignado'
        this.sMensaje = 'El punto leido no se encuentra asignado a esta ronda.'
        this.sTextoBtnAceptar = this.$STR.btnAceptar
        this.fAceptar = () =>{}
      }
    },
    cerrarlector(){
      this.isLecturaQR = false
      this.isLecturaNFC = false
    },
    onClickFinalizarRonda(){
      this.bDialog = true
      this.bBtnCancelDialgo = true
      this.sTituloMensaje = this.$STR.ttlRondaIncompleta
      this.sMensaje = this.$STR.msgFinalizarRondaIncompleta
      this.sTextoBtnAceptar = this.$STR.btnConfirmaContinuar
      this.fAceptar = this.onFinalizarRonda
    }

  },
  computed: {
    ...mapGetters(['getbMenuBlock', 'getbMarcacionQr']),
    tipoDePuntosTest() {
      return typeof this.puntosTest;
    },
    puntosAMostrar() {
      if (this.sFiltroBusqueda) {
        return this.puntos.filter(punto => punto.sNombrePunto.toLowerCase().includes(this.sFiltroBusqueda.toLowerCase()));
      }
      return this.puntos;
    },
}
}
</script>
<style lang="scss" scoped>
  .contenedor-bottom {
    /*position: fixed;
    bottom: 0;
    left: 0;*/
    margin-left: -12px !important;
    margin-right: -12px !important;
    margin-bottom: -12px;
  }

</style>  